import styles from "./InspectionCompleteModal.module.css";
import { Button, Modal } from "@shopify/polaris";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { InspectionSentences } from "../../config/SystemMessage";
import { PortalState } from "../../types/PortalState";
import { updateSurveyorCompletionStatus } from "../../store/actions/MarkSectionComplete";
import { AssetType } from "../../types/AssetType";
import { useState } from "react";
import SurveyorCompletionStatus from "../../types/SurveyorCompletionStatus";
import ReactGA from "react-ga4";

export default function InspectionCompleteModal() {
    const { t } = useTranslation("common");
    const status: SurveyorCompletionStatus | undefined = useSelector(
        (state: PortalState) =>
            state.portal.activeInspection?.SurveyorCompletionStatus
    );
    const dispatch = useDispatch();
    const [text, setText] = useState("");
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const emailAddress = t(
        InspectionSentences.INSPECTION_COMPLETE_EMAIL_ADDRESS
    );

    let active = false;

    if (status !== undefined) {
        if (
            status.PhotosComplete &&
            status.ChecklistComplete &&
            status.CarbonSectionComplete &&
            status.DocumentsComplete &&
            !status.InspectionComplete
        ) {
            active = true;
            ReactGA.event({
                category: "Inspection Status",
                action: "complete",
                value: 0
            });
        }
    }

    async function closeAndSubmitComment() {
        if (status !== undefined) {
            setSubmitDisabled(true);
            status.InspectionComplete = true;
            status.InspectionComment = text;
            ReactGA.event({
                category: "Inspection Status",
                action: "complete comment",
                label: text,
                value: 0
            });
            // Here we pass empty array of incomplete elements as this is handled individually for each section
            await dispatch(
                updateSurveyorCompletionStatus(status, AssetType.Complete, [],[])
            );
        }
    }

    const updateText = (event: any) => {
        setText(event.target.value);
    };

    return (
        <Modal
            open={active}
            onClose={closeAndSubmitComment}
            title={t(InspectionSentences.INSPECTION_COMPLETE_MODAL_TITLE)}
        >
            <Modal.Section>
                <div className={styles.container}>
                    <img
                        width="130px"
                        height="130px"
                        alt="big tick"
                        src={"/images/Big-Tick.svg"}
                    />
                </div>
                <p className={styles.firstParagraph}>
                    {t(InspectionSentences.INSPECTION_COMPLETE_MODAL_BODY) +
                        " "}
                    <a href={"mailto:" + emailAddress}>{emailAddress}</a>
                </p>
                <div className={styles.commentBox}>
                    <textarea onChange={updateText} placeholder="Comments" />
                </div>
                <div className={styles.container}>
                    <Button
                        size="large"
                        onClick={closeAndSubmitComment}
                        primary
                        disabled={submitDisabled}
                    >
                        {t(
                            InspectionSentences.INSPECTION_COMPLETE_MODAL_BUTTON
                        )}
                    </Button>
                </div>
            </Modal.Section>
        </Modal>
    );
}
